import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

/**
 * Unified loading spinner component with ESG styling
 */
export function LoadingSpinner({ size = 'md', text, className = '' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div
        className={`${sizeClasses[size]} border-evat-neon/30 border-t-evat-neon rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      />
      {text && (
        <div className="text-sm text-neutral-400 font-orbitron">{text}</div>
      )}
    </div>
  );
}

export default LoadingSpinner;






